var LaravelResponseUnwrapper = /** @class */ (function () {
    function LaravelResponseUnwrapper() {
    }
    LaravelResponseUnwrapper.prototype.unwrapResponse = function (data) {
        return data.data;
    };
    LaravelResponseUnwrapper.prototype.unwrapPaginationResponse = function (data) {
        return {
            data: data.data,
            currentPage: data.meta.current_page,
            total: data.meta.total,
            lastPage: data.meta.last_page
        };
    };
    return LaravelResponseUnwrapper;
}());
export { LaravelResponseUnwrapper };
export default LaravelResponseUnwrapper;
